import env from '../config/env';
import service from '../api/channelEntityPayment.service';
import permission from '../api/permissions.service';

//constants
const dataType = {
    securityPermission: null,
    types: [],
    channelEntityPayments: [],
    findByCollectingEntity: [],
    createChannelEntityPayment: [],
    deleteChannelEntityPayment: [],
    updateChannelEntityPayment: []
}
//types
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LIST_TYPE = 'LIST_TYPE'
const LIST_CHANNEL_ENTITY_PAYMENT = 'LIST_CHANNEL_ENTITY_PAYMENT'
const LIST_FIND_BY_COLLECTING_ENTITY = 'LIST_FIND_BY_COLLECTING_ENTITY'
const CREATE_CHANNEL_ENTITY_PAYMENT = 'CREATE_CHANNEL_ENTITY_PAYMENT'
const DELETE_CHANNEL_ENTITY_PAYMENT = 'DELETE_CHANNEL_ENTITY_PAYMENT'
const UPDATE_CHANNEL_ENTITY_PAYMENT = 'UPDATE_CHANNEL_ENTITY_PAYMENT'

//reducer
export default function channelEntityPaymentReducer(state = dataType, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LIST_TYPE:
            return { ...state, types: action.payload };
        case LIST_CHANNEL_ENTITY_PAYMENT:
            return { ...state, channelEntityPayments: action.payload };
        case LIST_FIND_BY_COLLECTING_ENTITY:
            return { ...state, findByCollectingEntity: action.payload };
        case CREATE_CHANNEL_ENTITY_PAYMENT:
            return { ...state, createChannelEntityPayment: action.payload };
        case DELETE_CHANNEL_ENTITY_PAYMENT:
            return { ...state, deleteChannelEntityPayment: action.payload };
        case UPDATE_CHANNEL_ENTITY_PAYMENT:
            return { ...state, updateChannelEntityPayment: action.payload };
        default:
            return { ...state };
    }
}

export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.paymentType,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const findByConcept= (concept) => async (dispatch) => {
    const response = await service.findByConcept(concept).then((r) => { return r.data });
    let data = [];
    if (response != null) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    label: element.name.toUpperCase(),
                });
            });
    }
    dispatch({
        type: LIST_TYPE,
        payload: data
    });
    return data;
}

export const findByCollectingEntity = (collectingEntity) => async (dispatch) => {
    let response = await service.getChannelEntityPayment(collectingEntity).then((r) => { return r.data });
    dispatch({
        type: LIST_FIND_BY_COLLECTING_ENTITY,
        payload: response
    });
    return response;
}

export const createChannelEntityPayment = (json) => async (dispatch) => {
    const response = await service.getCreateChannelEntityPayment(json).then((r) => { return r });
    dispatch({
        type: CREATE_CHANNEL_ENTITY_PAYMENT,
        payload: response
    });
    return response;
}

export const deleteChannelEntityPayment = (json) => async (dispatch) => {
    const response = await service.getDeleteChannelEntityPayment(json).then((r) => { return r });
    dispatch({
        type: DELETE_CHANNEL_ENTITY_PAYMENT,
        payload: response
    });
    return response;
}

export const updateChannelEntityPayment = (json) => async (dispatch) => {
    const response = await service.getUpdateChannelEntityPayment(json).then((r) => { return r });
    dispatch({
        type: UPDATE_CHANNEL_ENTITY_PAYMENT,
        payload: response
    });
    return response;
}